import axios from "axios";
import HttpError from "../http_error";

export default class WeatherRoutingAuthenticationService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  async authenticate() {
    try {
      const requestParams = {
        method: "POST",
        url: `${this.baseUrl}/authenticate`,
        headers: {
          "Content-type": "application/json",
          "access-token": `${localStorage.getItem("quad_token")}`,
          data: "{\"verified\":false}",
        },
      };
      const response = await axios.request(requestParams);
      localStorage.setItem("theyr_access_token", response.data.access_token);
      localStorage.setItem("theyr_refresh_token", response.data.refresh_token);
    } catch (error) {
      throw new HttpError(error.response.statusText, error.response.status);
    }
  }

  async refreshToken() {
    try {
      const requestParams = {
        method: "POST",
        url: `${this.baseUrl}/refresh-token`,
        headers: {
          "Content-type": "application/json",
          "access-token": `${localStorage.getItem("quad_token")}`,
        },
        data: {
          "token": localStorage.getItem("theyr_refresh_token")
        }
      };
      const response = await axios.request(requestParams);
      localStorage.setItem("theyr_access_token", response.data.access_token);
      localStorage.setItem("theyr_refresh_token", response.data.refresh_token);
      return response.data;
    } catch (error) {
      throw new HttpError(error.response.statusText, error.response.status);
    }
  }
}
